<h4 (click)="labelClick.emit()" [ngClass]="{'strong': bold}" [style.color]="color">{{label}}</h4>
<app-tags-group [tags]="tags" *ngIf="tags" size="" [iconClass]="iconClass"></app-tags-group>
